import { newLogger } from "@/utils/util";
import network from "../../../utils/network";
import Vue from "vue";
import eventBus, { EVENTS } from "@/utils/eventBus";
import { USER_STATUS } from "../../../utils/const";

let logger = newLogger("ProfileStore");

const CUSTOMER_STATUS_STORAGE_KEY =
  "fintrous_instacash_merchant_status_storage";

const urls = {
  profile: `/merchant/user/profile`,
  refreshUserStatus: "/bulwark/merchant-user/auth/refresh-user-status",
  // statusUpdate: "/profile/status",
  // passwordChange: `/bulwark/customer/password-change`,
  // isEmailConfirmed: "/bulwark/customer/is-email-confirmed",
  // sendConfirmationEmail: "/bulwark/customer/auth/send-confirmation-email",
  // changeEmail: "/bulwark/customer/auth/change-email",
  // changePhone: "/bulwark/customer/auth/change-phone",
  // confirmPhone: "/bulwark/customer/auth/confirm-phone",
};

/**
 * Customer store
 */

const initState = () => {
  let storedStatus = localStorage.getItem(CUSTOMER_STATUS_STORAGE_KEY);
  if (storedStatus) {
    if (storedStatus.includes(USER_STATUS.IN_FLOW)) {
      let states = storedStatus.split("|");
      return {
        profile: {
          status: states[0],
          flowPosition: states[1],
          flowPage: states[2],
        },
        statementAcceptances: [],
      };
    } else {
      return {
        profile: {
          status: storedStatus,
          flowPosition: null,
          flowPage: null,
        },
        statementAcceptances: [],
      };
    }
  } else {
    return {
      profile: {
        status: null,
        flowPosition: null,
        flowPage: null,
      },
      statementAcceptances: [],
    };
  }
};

const actions = {
  fetch: async ({ commit }) => {
    try {
      const axios = await network.connection();
      const { data } = await axios.get(urls.profile);
      commit("saveProfile", data);
    } catch (err) {
      logger.error(err);
      await Promise.reject(err);
    }
  },
  save: async ({}, request) => {
    try {
      const axios = await network.connection();
      await axios.put(urls.profile, request);
    } catch (err) {
      logger.error(err);
      await Promise.reject(err);
    }
  },
  // passwordChange: async ({ dispatch }, request) => {
  //   try {
  //     const axios = await network.connection();
  //     await axios.post(urls.passwordChange, request);
  //   } catch (err) {
  //     logger.error(err);
  //     await Promise.reject(err);
  //   }
  // },
  // emailChange: async ({ dispatch }, request) => {
  //   try {
  //     const axios = await network.connection();
  //     await axios.post(urls.changeEmail, request);
  //   } catch (err) {
  //     logger.error(err);
  //     await Promise.reject(err);
  //   }
  // },
  // phoneChange: async ({ dispatch, commit }, request) => {
  //   try {
  //     const axios = await network.connection();
  //     const response = await axios.post(urls.changePhone, request);
  //     return response.data.tokenId;
  //   } catch (err) {
  //     logger.error(err);
  //     await Promise.reject(err);
  //   }
  // },
  // confirmPhone: async ({ commit }, request) => {
  //   try {
  //     const axios = await network.connection();
  //     await axios.post(urls.confirmPhone, request);
  //   } catch (e) {
  //     logger.warn(e);
  //     return Promise.reject(e);
  //   }
  // },
  // fetchStatementAcceptances: async ({ commit }) => {
  //   try {
  //     const axios = await network.connection();
  //     const { data } = await axios.get(urls.statementAcceptances);
  //     commit("saveStatementAcceptances", data);
  //   } catch (err) {
  //     logger.error(err);
  //     await Promise.reject(err);
  //   }
  // },
  // sendConfirmationEmail: async ({ commit }, nonce) => {
  //   try {
  //     const axios = await network.connection();
  //     await axios.post(urls.sendConfirmationEmail, { nonce: nonce });
  //   } catch (err) {
  //     logger.error(err);
  //     await Promise.reject(err);
  //   }
  // },
  refreshUserStatus: async ({ commit }) => {
    try {
      const axios = await network.connection();
      const { data } = await axios.get(urls.refreshUserStatus);
      commit("saveLoginStatus", data);
      return data.status;
    } catch (err) {
      logger.error(err);
      await Promise.reject(err);
    }
  },
  setStatus: async ({ commit, getters }, loginResponse) => {
    commit("saveLoginStatus", loginResponse);
    return getters.getBackPath;
  },
  updateStatusLocal: async ({ commit }, status) => {
    commit("saveStatus", status);
  },
  // updateStatus: async ({ commit }, { status, result }) => {
  //   try {
  //     let axios = await network.connection();
  //     await axios.put(urls.statusUpdate, {
  //       currentStatus: status,
  //       currentStatusResult: result,
  //     });
  //     commit("saveStatus", status);
  //   } catch (err) {
  //     logger.error(err);
  //     await Promise.reject(err);
  //   }
  // },
  // isEmailConfirmed: async () => {
  //   try {
  //     let axios = await network.connection();
  //     let response = await axios.get(urls.isEmailConfirmed);
  //     return response.data;
  //   } catch (err) {
  //     logger.error(err);
  //     await Promise.reject(err);
  //   }
  // },
};

const mutations = {
  saveProfile: (state, data) => {
    state.profile = data;
    state.profile.status = data.currentStatus;
    state.profile.statusResult = data.currentStatusResult;
  },
  // saveStatementAcceptances: (state, data) => {
  //   Vue.set(state, "statementAcceptances", data);
  // },
  saveLoginStatus: (state, response) => {
    Vue.set(state, "profile", {});
    Vue.set(state.profile, "status", response.status);
    Vue.set(state.profile, "flowPosition", response.flowPosition);
    Vue.set(state.profile, "flowPage", response.flowPage);
    if (response.status.includes(USER_STATUS.IN_FLOW)) {
      localStorage.setItem(
        CUSTOMER_STATUS_STORAGE_KEY,
        `${response.status}|${response.flowPosition}|${response.flowPage}`
      );
    } else {
      localStorage.setItem(CUSTOMER_STATUS_STORAGE_KEY, response.status);
    }
  },
  saveStatus: (state, status) => {
    Vue.set(state.profile, "status", status);
    localStorage.setItem(CUSTOMER_STATUS_STORAGE_KEY, status);
    eventBus.$emit(EVENTS.STATUS_UPDATED);
  },
};

const getters = {
  get: (state) => {
    return state.profile;
  },
  // getStatementAcceptances: (state) => {
  //   return state.statementAcceptances;
  // },
  // hasActiveApplication: (state) => {
  //   return state.profile.status === "IN_FLOW";
  // },
  getStatus: (state) => {
    return state.profile.status;
  },
  isInState: (state) => (desired) => {
    return state.profile.status === desired;
  },
  getBackPath: (state) => {
    switch (state.profile.status) {
      case USER_STATUS.IN_FLOW:
        return "/application";
      case USER_STATUS.COMPLETED:
        return "/dashboard";
      case USER_STATUS.FAILED:
        return "/application-failed";
      case USER_STATUS.WAITING_FOR_FLOW:
        return "/application-check";
      default:
        return "/profile";
    }
  },
};

export default {
  namespaced: true,
  state: initState(),
  mutations: mutations,
  actions: actions,
  getters: getters,
};
